"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APDialogCard = void 0;
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var react_1 = __importDefault(require("react"));
var APScrollView_1 = require("../layout/APScrollView");
var APStack_1 = require("../layout/APStack");
var APFlex_1 = require("../layout/APFlex");
var APText_1 = require("./APText");
var Common_1 = require("../layout/Common");
var APCard_1 = require("./APCard");
function APDialogCard(_a) {
    var _b = _a.contentDivider, contentDivider = _b === void 0 ? false : _b, title = _a.title, children = _a.children, trailing = _a.trailing, leading = _a.leading, style = _a.style, contentDividerOffset = _a.contentDividerOffset;
    return (react_1.default.createElement(APCard_1.APCard, { style: __assign(__assign({ padding: "6px 20px 24px", minWidth: "420px" }, style), { boxSizing: "border-box" }) },
        react_1.default.createElement(APFlex_1.APColumn, { mainAxisSize: "max", crossAxisAlignment: "stretch" },
            react_1.default.createElement(APStack_1.APStack, { style: { height: "56px", marginBottom: "4px" } },
                react_1.default.createElement(APStack_1.APAlign, { align: 'fill' },
                    react_1.default.createElement(Common_1.APCenter, null,
                        react_1.default.createElement(APText_1.APText, { variant: 'dialogTitle', style: { marginLeft: "90px", marginRight: "90px", textAlign: 'center' } }, title))),
                leading && react_1.default.createElement(APStack_1.APAlign, { align: 'centerLeft' },
                    react_1.default.createElement(Common_1.APPadding, null, leading)),
                trailing && react_1.default.createElement(APStack_1.APAlign, { align: 'centerRight' },
                    react_1.default.createElement(Common_1.APPadding, { padding: "0px 0px", noClone: true }, trailing))),
            contentDivider && react_1.default.createElement(Divider_1.default, { style: { marginRight: contentDividerOffset } }),
            react_1.default.createElement(Common_1.APExpanded, null,
                react_1.default.createElement(APScrollView_1.APScrollView, null, children)))));
}
exports.APDialogCard = APDialogCard;
